<template lang="jade">
  .container-fluid.clearfix
    .mask(v-if='isMobile')
        h2 Please rotate your mobile to show config
    .row
      .layout_main.col-md-12
        header.layout_title_bar.main_title_bar.clearfix
          h1.title.col-md-4.col-sm-3.col-xs-3.clearfix.no_margin_v-xs
            | Layout
          .function_group.col-xs-4.col-md-4.pull-right
            .col-xs-4.no_pad-xs.clearfix.function__single.save_profile_btn.pull-right
              dropdown.col-md-12.no_pad
                button.col-sm-12.col-md-12.col-lg-12.btn.btn-primary.dropdown-toggle(slot='button' type='button')
                  i.fa.fa-save.fa-lg
                  span.caret
                ul.dropdown-menu(slot='dropdown-menu')
                  li(v-for='(key, opt) in profileOptions')
                    a(v-on:click='saveProfile(opt.value)') {{opt.label}}
            .col-xs-4.no_pad-xs.clearfix.function__single.edit_window.pull-right
              button.btn.btn-primary.col-sm-12.col-md-12.col-lg-12(v-on:click='handleWindowConfig')
                i.fa.fa-cog.fa-lg
          .ps_group.col-xs-5.col-sm-5.col-md-4.no_pad.clearfix.row_space--xxs.pull-right
            span.ps Output Resolution: {{outResolutionOptions[outResolution]}}
        section.layout_content.clearfix
          section.screen_block.clearfix.col-xs-12.col-md-12.col-lg-11.col-centered.no_pad
            section.screen_container.clearfix.col-xs-9.col-sm-9.col-md-9.no_pad(v-on:click='layoutChanged = true')
              v-screen.clearfix(
                v-bind:out-ratio.sync='outRatio'
                v-bind:splits.sync='splits'
                v-bind:out-resolution.sync='outResolution'
                v-bind:out-resolution-options.sync='outResolutionOptions'
                v-bind:out-layout.sync='outLayout'
                v-bind:which-split.sync='whichSplit'
                v-bind:window-focus.sync='focus'
                v-bind:layer.sync='editing.splitLayer'
                v-bind:show-window-config.sync='showWindowConfig'
                v-bind:label.sync='label'
                v-bind:resize-event.sync='InteractEvent'
                v-bind:mapping.sync='mapping'
                v-bind:editable='!in4K'
                )
              //- span Current output Radio({{outRatio[0]}}:{{outRatio[1]}}:{{outRatio[2]}}:{{outRatio[3]}})
              //- span.ps Current Resolution {{outResolutionOptions[outResolution]}}
            section.layer_functions_sec.col-xs-3.col-sm-3.col-md-3.clearfix
              //- span layer{{editing.splitLayer | json}}
              .layer_title.col-md-12.no_pad-xs
                h3 Layer
              .layer_area.col-xs-12.clearfix.no_pad-xs(v-if='!in4K')
                ul.dropzone.clearfix(v-sortable="{onEnd:onSortEnd}")
                  li.dragItem(
                    v-for='(key, layer) in editing.splitLayer'
                    v-bind:data-index='layer'
                    v-bind:data-bgColor='layer'
                    v-bind:class="{'focusMenu': focus === editing.splitLayer[key].toString()}" v-on:click='focus = editing.splitLayer[key].toString()')
                    span.token.col-xs-12.clearfix {{layerNameAry[layer]}}
              .layer_area.col-xs-12.clearfix.no_pad-xs(v-else)
                ul.dropzone.clearfix
                  li.dragItem(
                    v-for='(key, layer) in editing.splitLayer'
                    v-bind:data-index='layer'
                    v-bind:data-bgColor='layer'
                    v-bind:class="{'focusMenu': focus === editing.splitLayer[key].toString()}" v-on:click='focus = editing.splitLayer[key].toString()')
                    span.token.col-xs-12.clearfix {{layerNameAry[layer]}}
                  //-   span.token.col-xs-12.clearfix D
              .input_detail.col-xs-12.clearfix.no_pad-xs
                .col-xs-6.col-md-6.h_start
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits.setting[focus][0]" v-on:change="onInputChange(0)")
                .col-xs-6.col-md-6.h_end
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits.setting[focus][2]" v-on:change="onInputChange(2)")
                .col-xs-6.col-md-6.v_start
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits.setting[focus][1]" v-on:change="onInputChange(1)")
                .col-xs-6.col-md-6.v_end
                  input.col-xs-6.form-control(type='number' min=0 v-model="splits.setting[focus][3]" v-on:change="onInputChange(3)")
      modal.single_window_config(
        ok-text='Apply'
        cancel-text='Cancel'
        effect='zoom'
        v-bind:callback='applyWindowConfig'
        v-bind:show.sync='showWindowConfig'
        v-bind:title='editingWindow.title'
        backdrop='false')
        .modal-body.clearfix(slot='modal-body').row_space--xxs
          tabs
            tab(header='Source')
              section.window_setting_section.col-xs-12.clearfix
                span Selected Source:&nbsp;
                v-select(v-bind:options='sourceOptions' v-bind:value.sync='editingWindow.mapping[focus]')
                br
                span Original Resolution: {{outResolutionOptions[outResolution]}}
                button.btn.btn-primary.applySourceBtn(v-on:click="applyChgSource()")
                  | Apply
            tab(header='Label')
              section.source_selection_section.col-xs-12
                //- header.source_header.col-xs-12.no_pad
                //-   h2.title Label Options
                section.col-xs-12.clearfix.no_pad
                  //- .fa_checkbox.col-xs-12
                    input#labelOn(type='checkbox')
                    label(for='labelOn') Label On
                  .fa_checkbox.col-xs-12
                    input#osdLabel(type='checkbox' v-model='editingWindow.osd.enabled')
                    label(for='osdLabel')
                      span Enable OSD
                  .fa_checkbox.col-xs-4
                    input#winLabel(type='checkbox' v-model='editingWindow.window.enabled')
                    label(for='winLabel')
                      span Window Label
                  .fa_checkbox.col-xs-8
                    input#border(type='checkbox' v-model='editingWindow.enableBorder')
                    label(for='border')
                      span Border
                  .fa_checkbox.col-xs-4
                    input#sourceLabel(type='checkbox' v-model='editingWindow.input.enabled')
                    label(for='sourceLabel')
                      span Source Label
                  .fa_checkbox.col-xs-8(v-bind:class="{'disabled': !editingWindow.enableBorder}")
                    input#borderTally(type='checkbox' v-model='editingWindow.enableTally' v-bind:disabled="!editingWindow.enableBorder")
                    label(for='borderTally')
                      span Border Tally
              //- section.custom_section.col-xs-12
                section.col-xs-12.no_pad
                  .fa_checkbox.col-xs-12
                    input#customLabel(type='checkbox' v-model='editingWindow.custom.enabled')
                    label(for='customLabel') Custom Label
                  textarea.form-control(v-if='editingWindow.custom.enabled' v-model='editingWindow.custom.text' maxLength='10')
              section.custom_footer.col-xs-12.row_space--xxs
                button.btn.btn-primary.applyLabelBtn(v-on:click="applyChgLabel()")
                  | Apply
        .modal-footer.clearfix(slot='modal-footer')
          button.btn.btn-default(v-on:click="showWindowConfig = false")
            | Cancel
      modal.change_confirm(
        backdrop='false'
        title='Changes detected'
        v-bind:show.sync='showChgConfirm')
        .modal-header(slot='modal-header')
          button.close(v-on:click='stop')
            span x
          h4.modal-title
            | Changes detected
        .modal-body(slot='modal-body').clearfix
          .col-md-12
            span Save the change as Custome Preset?
          hr
          .col-md-12.saveTo
            label.pull-left Save to
            v-select.pull-left(v-bind:options='profileOptions' v-bind:value.sync='saveToPreset')
        .modal-footer(slot='modal-footer').clearfix
          button.btn.btn-default(v-on:click='leavePage')
            | No
          button.btn.btn-primary(v-on:click='applyCurrentChange')
            | Save

</template>

<script>
import { modal, dropdown, tabset, tab } from 'vue-strap'
import { call } from 'src/Service.js'
import singleSelect from 'src/components/Single-Select.vue'
import scr from 'src/components/Screen.vue'
import _ from 'lodash'
import MobileDetect from 'mobile-detect'
import $ from 'jquery'

export default {
  components: {
    modal,
    dropdown,
    tabs: tabset,
    tab,
    'v-select': singleSelect,
    'v-screen': scr
  },
  data () {
    return {
      InteractEvent: {},
      focus: '1',
      layerNameAry: ['', 'A', 'B', 'C', 'D'],
      editing: {
        _id: '',
        outRatio: [],
        outResolution: '',
        outLayout: '',
        outSplit: '',
        splitLayer: []
      },
      showWindowConfig: false,
      label: {},
      editingWindow: {
        _id: '',
        _name: '',
        title: '',
        showLabel: false,
        window: {},
        input: {},
        custom: {},
        osd: {},
        enableBorder: false,
        enableTally: false,
        mapping: {}
      },
      sourceOptions: [
        {label: 'Source 1', value: '1'},
        {label: 'Source 2', value: '2'},
        {label: 'Source 3', value: '3'},
        {label: 'Source 4', value: '4'}
      ],
      splits: {
        setting: {
          '1': [],
          '2': [],
          '3': [],
          '4': []
        }
      },
      splitLayer: [],
      links: {},
      crop: {},
      radio: {
        enlarge: 0,
        narrow: 0
      },
      outResolutionOptions: {},
      outResolution: '',
      outLayout: 'init', // quick , full or custom
      customSplit: '',
      fullScreenSplit: '',
      quickSelectSplit: '2*2',
      customLabelEnabled: false,
      ww: 0,
      wh: 0,
      profiles: {},
      mapping: {},
      showChgConfirm: false,
      saveToPreset: '1',
      layoutChanged: false,
      leavePage: () => {},
      applyCurrentChange: () => {},
      stop: () => {}
    }
  },
  async asyncData () {
    let { mac } = this.$route.params
    let newProfile = {}
    // save profile in $root to speed up
    if (!this.$root.mixerProfile) {
      this.$root.mixerProfile = {}
    }

    if (!this.$root.mixerProfile[mac]) {
      try {
        for (let i = 1; i < 9; i++) {
          console.log(i)
          let { profiles } = await call(mac, 'dxGetProfiles', {
            profile: i.toString()
          })
          newProfile[i] = profiles
        }

        this.profiles = _.cloneDeep(newProfile)
        this.$root.mixerProfile[mac] = newProfile
      } catch (err) {
        console.error(err)
      }
    } else {
      this.profiles = _.cloneDeep(this.$root.mixerProfile[mac])
    }

    call(mac, 'dxGetSplitArea').then(res => {
      this.splits = _.cloneDeep(res)
      return call(mac, 'dxGetOutputResolution')
    }).then(({resolution}) => {
      this.outResolution = resolution['1'] // remove toString() after unify the format
      return call(mac, 'dxGetOutputResolutionOptions')
    }).then(({options}) => {
      this.outResolutionOptions = options
      return call(mac, 'dxGetMixerStatus')
    }).then(({mapping}) => {
      this.mapping = mapping
      return call(mac, 'dxGetLabel')
    }).then((label) => {
      this.label = label
      return call(mac, 'dxGetSplitLayer')
    })
    .then(({layer}) => {
      this.editing.splitLayer = layer
      this.$broadcast('render', '1') // wait until all asyncData loaded and then emit 'render'
      this.$broadcast('chgZindex', layer, '1')
    })
    .catch(err => {
      console.log(err)
      this.alert('danger', '', err)
    })
  },
  computed: {
    in4K () {
      return this.outResolutionOptions[this.outResolution] === '3840x2160@60' || this.outResolutionOptions[this.outResolution] === '1080 to 4K2K@60'
    },
    outRatio () {
      console.log('in layout , change outRatio')
      let ratio = []
      switch (this.outResolutionOptions[this.outResolution]) {
        case '800x600':
        case '800x600@60':
        default:
          ratio = [4, 3, 200]  // [width, height, baseWidth]
          break
        case '3840x2160@60':
          ratio = [16, 9, 240]
          break
        case '1920x1200':
        case '1920x1200@60':
          ratio = [16, 10, 120]
          break
        case '1080 to 4K2K@60':
        case '1920x1080':
        case '1920x1080@60':
          ratio = [16, 9, 120]
          break
        case '1600x1200@60':
          ratio = [16, 12, 100]
          break
        case '1440x900@60':
          ratio = [8, 5, 180]
          break
        case '1400x900@60':
          ratio = [14, 9, 100]
          break
        case '1366x768@60':
          ratio = [16, 9, 85]
          break
        case '1280x1024@60':
          ratio = [5, 4, 256]
          break
        case '1280x960@60':
          ratio = [4, 3, 320]
          break
        case '1280x768@60':
          ratio = [5, 3, 256]
          break
        case '1280x720@60':
          ratio = [16, 9, 80]
          break
        case '1024x768@60':
          ratio = [4, 3, 256]
          break
        case '720x480@60':
          ratio = [3, 2, 240]
          break
        case '1680x1050@60':
          ratio = [8, 5, 210]
          break
        case '640x480':
        case '640x480@60':
          ratio = [4, 3, 160]
          break
      }

      let md = new MobileDetect(window.navigator.userAgent)
      if (md.mobile() !== null && window.innerWidth < 768) {
        this.ww = window.innerWidth
        if (this.ww === 568) { // i5 landscape
          ratio.push(Math.round(360 / ratio[0]))
        } else if (this.ww === 684) { // Nexus 5X landscape
          ratio.push(Math.round(500 / ratio[0]))
        } else if (this.ww > 568 && this.ww <= 667) { // i6 landscape
          ratio.push(Math.round(460 / ratio[0]))
        } else if (this.ww > 667 && this.ww <= 736) { // i6+ landscape
          ratio.push(Math.round(520 / ratio[0]))
        } else { // set 300 to others
          ratio.push(Math.round(300 / ratio[0]))
        }
      } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
        ratio.push(Math.round(480 / ratio[0])) // ipad UP
      } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
        ratio.push(Math.round(600 / ratio[0])) // md
      } else if (window.innerWidth >= 1200) {
        ratio.push(Math.round(800 / ratio[0])) // lg
      }

      return ratio
    },
    isMobile () {
      let md = new MobileDetect(window.navigator.userAgent)
      return md.mobile() !== null && this.wh > this.ww
    },
    computedOutResolutionOptions () {
      let options = []
      let keys = Object.keys(this.outResolutionOptions)
      for (let key of keys) {
        options.push({
          label: this.outResolutionOptions[key],
          value: key
        })
      }
      return options
    },
    whichSplit () {
      if (this.outLayout === 'quick') {
        return this.quickSelectSplit
      } else if (this.outLayout === 'full') {
        return this.fullScreenSplit
      } else if (this.outLayout === 'custom') {
        return this.customsplit
      }
    },
    profileOptions () {
      let opts = []
      for (let profile in this.profiles) {
        opts.push({
          label: this.profiles[profile].name,
          value: profile
        })
      }
      return opts
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    onSortEnd (event) {
      if (this.in4K) return
      this.layoutChanged = true
      let newLayer = []
      let newEditing = _.cloneDeep(this.editing)
      let { mac } = this.$route.params

      $.each($('.dragItem'), (i, val) => {
        newLayer.push(parseInt($(val).attr('data-index')))
      })
      newEditing.splitLayer = _.cloneDeep(newLayer)
      this.editing = _.cloneDeep(newEditing)

      let params = {
        layer: this.editing.splitLayer
      }

      call(mac, 'dxSetSplitLayer', params).then(res => {
      })
    },
    _editingWindowBorderToBoolean () {
      if (this.label.osd[this.focus].border === 0) {
        this.editingWindow.enableBorder = false
        this.editingWindow.enableTally = false
      } else if (this.label.osd[this.focus].border === 1) {
        this.editingWindow.enableBorder = true
        this.editingWindow.enableTally = false
      } else if (this.label.osd[this.focus].border === 2) {
        this.editingWindow.enableBorder = true
        this.editingWindow.enableTally = true
      }
    },
    _editingBooleanToWindowBorder () {
      let border = this.editingWindow.enableBorder
      let tally = this.editingWindow.enableTally

      if (border & tally) {
        this.editingWindow.osd.border = 2
      } else if (border & !tally) {
        this.editingWindow.osd.border = 1
      } else if (!border) {
        this.editingWindow.osd.border = 0
      }
    },
    handleWindowConfig () {
      if (!this.focus) return this.alert('danger', '', 'Please select a window')

      this.editingWindow.window = _.cloneDeep(this.label.windows[this.focus])
      this.editingWindow.input = _.cloneDeep(this.label.inputs[this.focus])
      this.editingWindow.custom = _.cloneDeep(this.label.custom[this.focus])
      this.editingWindow.osd = _.cloneDeep(this.label.osd[this.focus])
      this.editingWindow.mapping = _.cloneDeep(this.mapping)
      let windowName = ['', 'A', 'B', 'C', 'D']

      this._editingWindowBorderToBoolean()

      this.editingWindow._id = this.focus
      this.editingWindow._name = windowName[this.focus]
      this.editingWindow.title = 'Window ' + windowName[this.focus]

      // @Todo: enableBorder and border Tally
      this.showWindowConfig = true
    },
    applyChgSource () {
      let { mac } = this.$route.params
      let params2 = {
        // mapping: this.editingWindow.mapping
        mapping: {
          [this.focus]: this.editingWindow.mapping[this.focus]
        }
      }

      call(mac, 'dxSetMapping', params2).then(res => {
        console.log('done setMapping', res)
      }).catch(err => {
        this.alert('danger', '', err)
      })
    },
    applyChgLabel () {
      let { mac } = this.$route.params
      this._editingBooleanToWindowBorder()
      let params = {
        osd: {
          [this.editingWindow._id]: this.editingWindow.osd
        },
        windows: {
          [this.editingWindow._id]: this.editingWindow.window
        },
        inputs: {
          [this.editingWindow._id]: this.editingWindow.input
        },
        custom: {
          [this.editingWindow._id]: this.editingWindow.custom
        }
      }

      // this.showWindowConfig = false
      call(mac, 'dxSetLabel', params).then(res => {
      })
      .catch(err => {
        this.alert('danger', '', err)
      })
    },
    applySplit (target) {
      let { mac } = this.$route.params
      let params2 = {
        setting: {
          [this.focus]: this.splits.setting[this.focus]
        }
      }
      console.log(params2)
      call(mac, 'dxSetSplitArea', params2).then(res => {
        // this.alert('success', '', 'Current config changed')
      }).catch(err => {
        this.alert('danger', '', err)
      })
    },
    saveProfile (key) {
      console.log(key)
      let { mac } = this.$route.params
      call(mac, 'dxSetProfileByKey', {profiles: key}).then(res => {
        console.log(res)
        this.layoutChanged = false
      }).catch(err => {
        this.alert('danger', '', err)
      })
    },
    updateRootMixerProfile (key, profile) {
      let { mac } = this.$route.params
      console.log(key)
      this.profiles[key] = _.cloneDeep(profile)
      this.$root.mixerProfile[mac][key] = _.cloneDeep(profile)
    },
    onInputChange (index) {
      if (this.in4K) return
      switch (index) {
        case 0:
          if (parseInt(this.splits.setting[this.focus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0')
          break
        case 2:
          if (this.splits.setting[this.focus][0] >= parseInt(this.splits.setting[this.focus][2]) || parseInt(this.splits.setting[this.focus][index]) > this.outRatio[0] * this.outRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen width')
          break
        case 1:
          if (parseInt(this.splits.setting[this.focus][index]) < 0) return this.alert('danger', '', 'The split entered needs to be larger than 0')
          break
        case 3:
          if (this.splits.setting[this.focus][1] >= parseInt(this.splits.setting[this.focus][3]) || parseInt(this.splits.setting[this.focus][index]) > this.outRatio[1] * this.outRatio[2]) return this.alert('danger', '', 'The split entered needs to be larger than the start or smaller than screen height')
          break
      }
      this.layoutChanged = true
      this.splits.setting[this.focus][index] = parseInt(this.splits.setting[this.focus][index])
      this.applySplit(this.focus)
      this.$broadcast('render', '1')
    },
    addListener () {
      this.ww = window.innerWidth
      this.wh = window.innerHeight
      setTimeout(() => {
        console.log('ww')
        console.log(this.ww)
        this.$broadcast('render', '1')
      }, 1000)
    },
    applyCurrentChange () {
      console.log('meht')
    },
    leavePage () {
      console.log('asdfadfsas')
    }
  }, // close methods
  ready () {
    this.ww = window.innerWidth
    this.wh = window.innerHeight
    window.addEventListener('orientationchange', this.addListener, false)
    window.addEventListener('resize', this.addListener, false)
  },
  route: {
    deactivate (transition) {
      let vue = this
      window.removeEventListener('orientationchange', this.addListener, false)
      window.removeEventListener('resize', this.addListener, false)
      if (!this.layoutChanged) {
        transition.next()
      } else {
        return new Promise(function (resolve, reject) {
          vue.showChgConfirm = true
          vue.leavePage = () => {
            resolve()
          }
          vue.applyCurrentChange = async () => {
            vue.saveProfile(vue.saveToPreset)
            resolve()
          }
          vue.stop = () => {
            reject()
            vue.showChgConfirm = false
          }
        })
      }
    }
  },
  events: {
    resizeend ({target}) {
      console.log('target', target)
      this.applySplit(target)
    },
    dragend ({target}) {
      console.log('target', target)
      this.applySplit(target)
    },
    gestureend ({target}) {
      console.log('gesture', target)
      this.applySplit(target)
    },
    resizemove (event) {
      this.InteractEvent = _.cloneDeep(event)
    },
    update (mac, {type, event, msg}) {
      console.log('got event:', type)
      switch (type) {
        case 'layer':
          this.splitLayer = event.layer
          setTimeout(() => {
            this.$broadcast('chgZindex', this.splitLayer, '1')
          }, 700)
          break
        case 'mapping':
          let newMapping = _.cloneDeep(this.mapping)
          _.assignIn(newMapping, event)
          this.mapping = _.cloneDeep(newMapping)
          break
        case 'split':
          console.log(event)
          let newSplit = _.cloneDeep(this.splits)
          _.assignIn(newSplit.setting, event.setting)
          this.splits = _.cloneDeep(newSplit)
          this.outLayout = 'init'
          setTimeout(() => {
            this.$broadcast('render', '1')
          }, 700)
          break
        case 'label':
          console.log(event)
          let newLabel = _.cloneDeep(this.label)
          let {inputs = {}, windows = {}, custom = {}, osd = {}} = event

          if (inputs) _.assignIn(newLabel.inputs, event.inputs)
          if (windows) _.assignIn(newLabel.windows, event.windows)
          if (custom) _.assignIn(newLabel.custom, event.custom)
          if (osd) _.assignIn(newLabel.osd, event.osd)

          this.label = _.cloneDeep(newLabel)
          this._editingWindowBorderToBoolean()
          break
        case 'resolution':
          this.outResolution = event['1']

          setTimeout(() => {
            this.$broadcast('render', '1')
          }, 700)
          break
        case 'preset':
          let key = Object.keys(event)[0]
          this.updateRootMixerProfile(key, event[key])
          break
      }
    }
  },
  watch: {
    outLayout (nv) {
      if (nv === 'full') {
        this.fullScreenSplit = '1'
      }
    },
    outRatio (nv) {
    },
    showWindowConfig (nv) {
      if (!nv) {
        $('.single_window_config').scrollTop(0)
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.container-fluid{
  height: calc(100vh - 100px);
  @include breakpoint(md){
    height: auto;
  }
  @include breakpoint(sm){
    height: auto;
  }
  @include breakpoint(landXS){
    height: auto;
  }
}
.layout_title_bar{
  .title{
    @include breakpoint(xs) {
      padding-top: $space_xxs;
      padding-bottom: $space_xxs;
    }
  }
}
.ps_group{
  z-index: 50;
  position: fixed;
  left: 33%;
  @include breakpoint(landSixPlus) {
    left: 28%;
  }
}
.ps{
  display:inline-block;
  width:100%;
  text-align:center;
  font-size: 10px;
  @include breakpoint(landFive) {
    left: 0;
  }
}

.screen_block{
  padding: 0;
  @include breakpoint(md) {
    padding-top: $space_sm;
  }
  @include breakpoint(lg) {
    padding-top: $space_sm;
  }
}
.mask{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  left: 0;
  top: 0;
  text-align: center;
  line-height: 100%;
  background-color: $base-black;
  color: $base-white;
  & h2{
    position: fixed;
    margin-top: 30%;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    color: #fff;
  }
  @include breakpoint(landXS) {
    display: none;
  }
}

.token{
  outline: 1px solid $pri_gray;
}
.sortable-fallback{
  display: none;
}
.sortable-chosen{
  & .token{
    outline: 2px solid $pri_dark;
  }
}
.layer_functions_sec{
  padding-left: 25px;
  padding-right: 5px;
}
.layer_title{
  & h3{
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
ul.dropzone{
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5px;
  text-align: center;
  @include breakpoint(landSixPlus) {
    height: 200px;
  }
  @include breakpoint(landSix){
    height: 160px;
  }
  @include breakpoint(landFive) {
    height: 120px;
  }
  @include breakpoint(sm) {
    height: 110px;
  }
}
li.dragItem{
  text-align: center;
  color: $base_black;
  @include breakpoint(landSixPlus) {
    height: 50px;
    line-height: 50px;
  }
  @include breakpoint(landSix) {
    height: 40px;
    line-height: 40px;
  }
  @include breakpoint(landFive) {
    height: 30px;
    line-height: 30px;
  }
  @include breakpoint(md){
    height: 50px;
    line-height: 50px;
  }
  @include breakpoint(lg){
    height: 50px;
    line-height: 50px;
  }
  .token{
    height: 100%;
    line-height: inherit;
    /* @include breakpoint(landSix) {
      height: 40px;
      line-height: 40px;
    } */
  }
  @each $i in $window_colors{
    &[data-bgColor='#{nth($i, 1)}']{
      .token{
        background-color: nth($i,2);
      }
    }
  }

  &.focusMenu{
    border: 1px solid $base_black;
    color: $base_white;
  }
}
.input_detail{
  padding-top: 5px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 25px;
  padding-right: 0px;
  @include breakpoint(md) {
    padding-top: $space_md;
  }
  @include breakpoint(lg) {
    padding-top: $space_md;
  }
  & label{
    font-size: 12px;
  }
  & .form-control{
    padding: 7px 5px;
    text-align: center;
    transition: all .3s;
    transform: scale(0.7,0.7);
    transform-origin: 0 0;
    &:focus{
      transform: scale(.85, .9)
    }
  }
  & .h_start::before{
    content: 'H:';
  }
  & .h_end::before, .v_end::before{
    content: 'to';
    margin-left: -9px;
  }
  & .v_start::before{
    content: 'V:';
  }

  & .h_start, .h_end, .v_start, .v_end{
    position: relative;
    padding-left: 20px;
    padding-right: 0px;
    &::before{
      position: absolute;
      display: block;
      left: 0px;
      top: 0;
    }
    & .form-control{
      padding: 3px;
    }
  }
}

.window_setting_section{
  padding-bottom: 5px;
  padding-right: 0;
}
.applySourceBtn, .applyLabelBtn{
  float: right;
}


.single_window_config{
  top: 30px;
}
.function__single{
  .btn-primary{
    color: $base_white;
  }
  .btn{
    margin-top: 14px;
  }
  &.save_profile_btn{
    .caret{
      margin-right: -6px;
      margin-left: 4px;
    }
    .dropdown-menu{
      left: -80%;
    }
  }
}
.fa_checkbox{
  & label{
    font-weight: 500;
  }
}
.fa_checkbox.disabled{
  opacity: .5;
  label{
    cursor: default;
  }
}
.saveTo{
  label {
    margin-top: 4px;
    margin-right: 6px;
    white-space: nowrap;
  }
}
.function_group{
  position: fixed;
  z-index: 50;
  right: 15px;
  margin-top: -9px;
  @include breakpoint(landFive) {
    padding-top: 12px;
  }
  @include breakpoint(landSix) {
    padding-top: 13px;
  }
  @include breakpoint(landSixPlus) {
    padding-top: 14px;
  }
  & .function__single {
    text-align: center;
  }
  & .function__single .btn {
    @include breakpoint(landFive) {
      margin-top: 0px;
      padding: 3px 7px;
    }
    @include breakpoint(landSix) {
      margin-top: 0px;
      padding: 3px 7px;
    }
    @include breakpoint(landSixPlus) {
      margin-top: 0px;
      padding: 3px 7px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Layout.vue?75440151